export const ACTION_UPDATE_MODEL_STEPSBLOCK = 'ACTION_UPDATE_MODEL_STEPSBLOCK';
export const ACTION_REMOVE_MODEL_STEPSBLOCK = 'ACTION_REMOVE_MODEL_STEPSBLOCK';
export const ACTION_UPDATE_SLIDE_ID_STEPSBLOCK = 'ACTION_UPDATE_SLIDE_ID_STEPSBLOCK';
export const ACTION_REMOVE_SLIDE_ID_STEPSBLOCK = 'ACTION_REMOVE_SLIDE_ID_STEPSBLOCK';

export const updateStepBlockModel = ({dataModel}) => ({
    payload: {
        model: dataModel
    },
    type: ACTION_UPDATE_MODEL_STEPSBLOCK
});

export const updateStepBlockSlideId = ({activeStep}) => ({
    payload: {
        activeStep
    },
    type: ACTION_UPDATE_SLIDE_ID_STEPSBLOCK
});

export const removeLastStepBlockSlideId = () => ({
    type: ACTION_REMOVE_SLIDE_ID_STEPSBLOCK
});

export const removeLastStepBlockModel = () => ({
    type: ACTION_REMOVE_MODEL_STEPSBLOCK
});
